import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { ModalUI } from '../../common';
import { Validate } from '../../../other';

const ModalRevocar = (props) => {
  let { revocar, handleSubmit, modalHandler, modal_state, form_state } = props;

  return (
    <ModalUI
      open={modal_state}
      id="revocar"
      title="Revocar acceso mayorista"
      modalHandler={modalHandler}
      aditional_param="revocar"
      handleSubmit={handleSubmit}
      button_label="Revocar"
      button_disabled={false}
      button_loading={form_state}
    >
      <Grid container spacing={24}>
        <Grid item xs={12}>
          <Typography>
            ¿Está seguro que quiere cancelarle el acceso mayorista a{' '}
            {Validate.trim_ucwords(
              revocar.cl_nombre + ' ' + revocar.cl_apellido
            )}
            ? Su cuenta pasará a ser minorista.
          </Typography>
        </Grid>
      </Grid>
    </ModalUI>
  );
};

export { ModalRevocar };
